import { config } from '@/config'

export const authService = {
  login,
  logout,
  handleResponse,
  getCurrent
}

function handleResponse (response, { skipReload = false } = {}) {
  if (!response.ok) {
    if (response.status === 401 && !skipReload) {
      logout()
      location.reload(true)
      return
    }
  }
  return response.text().then(text => {
    try {
      const data = text && JSON.parse(text)
      if (!response.ok) {
        const error = (data && data.message) || response.statusText
        return Promise.reject(error)
      }
      return data
    } catch (e) {
      return text
    }
  })
}

function login (login, password) {
  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ login, password })
  }

  return fetch(config.api.auth.login, requestOptions)
    .then(r => handleResponse(r, { skipReload: true }))
    .then(response => {
      // login может вернуть HTTP 200 с status: error (неверный пароль)
      if (!response || response.status === 'error' || !response.data) {
        return Promise.reject(response && response.message ? response.message : 'login failed')
      }
      return getCurrent().then(userResponse => {
        if (!userResponse || !userResponse.data) {
          return Promise.reject(new Error('current user failed'))
        }
        // role остаётся только для отображения (пункты меню в NavigationPanel.vue) —
        // ни один route guard и ни один API-запрос ему не доверяет, авторизацию
        // всегда решает бэкенд (C9/H22). Убирать role отсюда нельзя: без него
        // NavigationPanel.vue.menuItems() фильтрует по authorize.includes(undefined)
        // и меню оказывается пустым для всех пользователей независимо от роли.
        const { password, ...safeUser } = userResponse.data
        localStorage.setItem('user', JSON.stringify(safeUser))
        return userResponse.data
      })
    })
}

function logout () {
  localStorage.removeItem('user')
  fetch(config.api.auth.logout, { method: 'POST', credentials: 'include' }).catch(() => {})
}

function getCurrent () {
  return fetch(config.api.user.current, {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' }
  }).then(handleResponse)
}
